import WinnersSection from '@containers/Campaigns/RealPeopleRealConnections/Components/WinnersSection/WinnersSection';

export default WinnersSection;